<div class="desktop">
    <div class="card mensaje">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1" style="width: 55px; margin-top: 5px;">
                        <div class="linea"></div>
                        <img class="iconoinformacionCard" src="./assets/img/IconoMensaje.png">
                    </div>
                    <div class="col">
                        <div class="proceso" style="padding-top: 5px;">
                            El precio que estás viendo es una estimación inicial.
                            <br><br>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detalleMobile">
                            El valor puede variar de acuerdo al perfil de tu inquilino, la vigencia del contrato (6 o 12
                            meses) y el plan que elijas.
                            Pero tranqui, no superará el valor mensual de tu arriendo mas el de la administración
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modile">
    <div class="card mensaje">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col-auto" style="padding-top: 5px;">
                        <div class="linea"></div>
                        <img class="iconoinformacionCard" src="./assets/img/IconoMensaje.png">
                    </div>
                    <div class="col">
                        <div class="proceso">
                            El precio que estás viendo es una estimación inicial.
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detalleMobile">
                            El valor puede variar de acuerdo al perfil de tu inquilino, la vigencia del contrato (6 o 12
                            meses) y el plan que elijas.
                            Pero tranqui, no superará el valor mensual de tu arriendo mas el de la administración
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>